// 设置身份证号的验证规则
const idCard = (rule, value, callback) => {
    if (!value) {
        callback(new Error('请输入身份证号'))
    } else {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (reg.test(value)) {
            callback()
        } else {
            return callback(new Error('请输入正确的身份证号'))
        }
    }
}
// 设置手机号的验证规则
const checkPhone = (rule, value, callback) => {
    // console.log(value)
    if (!value) {
        callback(new Error('请输入手机号码'))
    } else {
        const reg = /^1[3-9]\d{9}$/
        if (reg.test(value)) {
            callback()
        } else {
            console.log('请输入')
            callback(new Error('请输入正确的手机号码'))
        }
    }
}

//汉字验证
//pattern: /^[\u4E00-\u9FA5]+$/

export default {idCard,checkPhone}



// WEBPACK FOOTER //
// ./src/assets/js/customValidate.js